var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"type-list"},[_c('ul',_vm._l((_vm.typeList),function(item,index){return _c('li',{key:index,class:{'active': _vm.currentIndex === index},on:{"click":function($event){return _vm.changeType(index)}}},[_c('div',{staticClass:"con"},[_c('span',{staticClass:"tit"},[_vm._v(_vm._s(item.name))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }